import {Component, Input, OnInit} from '@angular/core';
import {IncidentTransaction} from '@npck/af-frontend-api';
import {DictionaryHolderService, resolveRefName} from '../../../../../../../domain/dictionary-holder.service';

interface PaymentInfoField {
    label: string;
    value: string;
}

@Component({
    selector: 'af-transaction-payment-info-tab',
    templateUrl: 'incident-transaction-payment-info-tab.component.html',
    styleUrls: ['../transaction-details-tab/incident-transaction-details-tab.component.scss'],
    standalone: false,
})
export class IncidentTransactionPaymentInfoTabComponent implements OnInit {
    @Input() transaction: IncidentTransaction;

    fields: PaymentInfoField[] = [];

    constructor(private dictionaryHolderService: DictionaryHolderService) {
    }

    ngOnInit(): void {
        const merchantInfo = this.transaction.merchantInfo;
        if (!merchantInfo) {
            return;
        }
        this.dictionaryHolderService.getReference('merchant_category_code').subscribe(categories => {
            const categoryCode = merchantInfo.categoryCode;
            const categoryName = resolveRefName(categories, categoryCode);
            this.fields = [
                {label: 'i18n_af_labelMerchantName', value: merchantInfo.name || '-'},
                {label: 'i18n_af_labelMerchantId', value: merchantInfo.merchantId || '-'},
                {
                    label: 'i18n_af_labelMerchantCategoryCode',
                    value: categoryName && categoryName !== categoryCode
                        ? `${categoryCode} - ${categoryName}`
                        : categoryCode || '-',
                },
                {label: 'i18n_af_labelTerminalId', value: merchantInfo.terminalId || '-'},
                {label: 'i18n_af_labelDeviceIp', value: merchantInfo.deviceIp || '-'},
            ];
        });
    }
}
